import * as React from "react";
import * as ScrollAreaPrimitive from "@radix-ui/react-scroll-area";
import { cn } from "../../lib/utils";
const ScrollArea = React.forwardRef(({ className, children, ...props }, ref) => (<ScrollAreaPrimitive.Root ref={ref} className={cn("va-scroll-area", className)} {...props}>
    <ScrollAreaPrimitive.Viewport style={{ height: "100%", width: "100%" }}>
      {children}
    </ScrollAreaPrimitive.Viewport>
    <ScrollBar />
    <ScrollAreaPrimitive.Corner />
  </ScrollAreaPrimitive.Root>));
ScrollArea.displayName = ScrollAreaPrimitive.Root.displayName;
const ScrollBar = React.forwardRef(({ className, orientation = "vertical", ...props }, ref) => {
    const dimension = orientation === "vertical"
        ? { height: "100%", width: "12px" }
        : { width: "100%", height: "12px" };
    return (<ScrollAreaPrimitive.ScrollAreaScrollbar ref={ref} orientation={orientation} className={cn(className)} style={dimension} {...props}>
      <ScrollAreaPrimitive.ScrollAreaThumb style={{
                position: "relative",
                flex: 1,
                borderRadius: "999px",
                background: "hsl(var(--muted))",
            }}/>
    </ScrollAreaPrimitive.ScrollAreaScrollbar>);
});
ScrollBar.displayName = ScrollAreaPrimitive.ScrollAreaScrollbar.displayName;
export { ScrollArea, ScrollBar };
